<div class="analytics-portlet-Img100p display-preroll-carousel-height {{ sectionclass }}" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<!-- this below span is for ltr2 where we need header in no data scenariio -->
	<span *ngIf="!hasData" class="header"></span>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary u-color-white-900"
		*ngIf="hasData"
	>
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
			style="position: relative"
		>
			<div class="o-stack__cell portlet-subheader-wrapper">
				<div class="r8-creatives-heading" style="display: none">Video Creative Performance</div>
				<h5 *ngIf="isR104" class="portlet-subheader r8-portlet-subheader r104-creatives">
					{{ setDisplayProperties.name }}
				</h5>
				<h5 class="portlet-subheader r8-portlet-subheader">{{ setDisplayProperties.name }}</h5>
				<h6 class="portlet-subheader" style="font-size: 1.1em" *ngIf="!isR103 && !isDOOH && displayData?.length > 0">
					{{ count }} of {{ displayData.length }} pre roll creatives in selected date range
				</h6>
				<h6 class="portlet-subheader" style="font-size: 1.1em" *ngIf="isR103 && isDOOH && displayData?.length > 0">
					{{ count }} of {{ displayData.length }} dooh video creatives in selected date range
				</h6>
				<h6
					class="portlet-subheader r104-creatives"
					style="font-size: 1.1em"
					*ngIf="isR104 && displayData && displayData?.length > 0"
				>
					{{ count }} | {{ displayData.length }}
				</h6>
				<h6
					class="portlet-subheader r8-portlet-subheader"
					style="font-size: 1.1em; display: none"
					*ngIf="displayData && displayData?.length > 0"
				>
					{{ count }} of {{ displayData.length }} creatives
				</h6>
				<h6
					class="portlet-subheader r101-style"
					style="font-size: 1.1em; display: none"
					*ngIf="displayData && displayData?.length > 0"
				>
					{{ count }} | {{ displayData.length }}
				</h6>
				<h6 *ngIf="setDisplayProperties.mp4 == ''" class="portlet-subheader no-creative" style="font-size: 1.1em">
					No Data to Display
				</h6>
				<h6 *ngIf="setDisplayProperties.mp4 == null" class="portlet-subheader no-video-to-play">No Video to Play</h6>
				<a
					href="#"
					class="datatable_download_icon"
					*ngIf="setDisplayProperties && downloadConfiguration && downloadConfiguration.enableDownload"
					(click)="downloadDataInCSV($event)"
					target="_blank"
				>
					<i class="fa fa-download" aria-hidden="true"></i>
				</a>
			</div>
			<div class="o-stack__cell">
				<div class="o-stack o-stack&#45;&#45;center o-stack&#45;&#45;nowrap o-stack&#45;&#45;tinyGap u-font-small">
					<div
						class="o-stack__cell u-relative"
						style="position: absolute; left: 90%"
						*ngIf="setDisplayProperties && carouselItemsLength > 1"
					>
						<a class="c-icon c-icon&#45;&#45;main u-color-minor u-opacity-50p">
							<span class="next" (click)="nextArrow()" class="carousel-arrow-style">
								<i class="fa fa-angle-left" aria-hidden="true"></i>
							</span>
						</a>
						<a class="c-icon c-icon&#45;&#45;main u-color-minor u-opacity-50p" style="margin-left: 5px">
							<span class="prev" (click)="prevArrow()" class="carousel-arrow-style">
								<i class="fa fa-angle-right" aria-hidden="true"></i>
							</span>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="!isR8" class="c-portlet__content u-pt-small">
			<div
				*ngIf="!isR101 && !isR102"
				class="o-stack o-stack&#45;&#45;center preroll-creative-img"
				id="videoDisplayblock"
			>
				<div style="margin: 1em 1em 0em 1em; width: 100%; background-color: black">
					<div class="ShowControls" *ngIf="!isSocial && !isRadio">
						<video
							class=""
							(click)="controlsOptions()"
							[hidden]="showLoad"
							style="width: 100%"
							id="preRollvideo"
							autoplay
							muted
							#videoName
							[src]="setDisplayProperties.mp4"
						>
							<source type="video/mp4" />
							Your browser does not support HTML5 video.
						</video>
						<div class="showIconsControls">
							<span class="playVideo" (click)="playclickEvent()">
								<img id="playBtn" class="volumeClass" src="./assets/images/play.png" />
							</span>
							<span class="playVideo" (click)="pauseclickEvent()">
								<img id="pauseBtn" class="volumeClass" src="./assets/images/pause.png" />
							</span>
						</div>
					</div>
				</div>
				<div class="volumecontrols" [hidden]="showLoad">
					<span id="volumeBtn" class="volumeControlIcon" (click)="volumeclick()">
						<!--<i class="volumecontrols fa fa-volume-up"></i>-->
						<span class="VolumeControlHoverClass">&nbsp;&nbsp;&nbsp;MUTE&nbsp;&nbsp;&nbsp;</span>
						<img id="volumebtn" class="volumeClass" src="./assets/images/muteicon.png" />
					</span>
					<span id="muteBtn" class="volumeControlIcon" (click)="muteclick()">
						<!--<i class="volumecontrols fa fa-volume-off"></i>-->
						<span class="VolumeControlHoverClass">UNMUTE</span>
						<img id="mutebtn" class="volumeClass" src="./assets/images/unmuteicon.png" />
					</span>
				</div>
			</div>
			<div
				*ngIf="(isR101 || isR102) && setDisplayProperties.mp4"
				class="o-stack o-stack&#45;&#45;center preroll-creative-img"
				id="videoDisplayblock"
			>
				<div style="margin: 1em 1em 0em 1em; width: 100%; background-color: black">
					<div class="ShowControls" *ngIf="!isSocial && !isRadio">
						<video
							class=""
							(click)="controlsOptions()"
							[hidden]="showLoad"
							style="width: 100%"
							id="preRollvideo"
							autoplay
							muted
							#videoName
							[src]="setDisplayProperties.mp4"
						>
							<source type="video/mp4" />
							Your browser does not support HTML5 video.
						</video>
						<div class="showIconsControls">
							<span class="playVideo" (click)="playclickEvent()">
								<img id="playBtn" class="volumeClass" src="./assets/images/play.png" />
							</span>
							<span class="playVideo" (click)="pauseclickEvent()">
								<img id="pauseBtn" class="volumeClass" src="./assets/images/pause.png" />
							</span>
						</div>
					</div>
				</div>
				<div class="volumecontrols" [hidden]="showLoad">
					<span id="volumeBtn" class="volumeControlIcon" (click)="volumeclick()">
						<!--<i class="volumecontrols fa fa-volume-up"></i>-->
						<span class="VolumeControlHoverClass">&nbsp;&nbsp;&nbsp;MUTE&nbsp;&nbsp;&nbsp;</span>
						<img id="volumebtn" class="volumeClass" src="./assets/images/muteicon.png" />
					</span>
					<span id="muteBtn" class="volumeControlIcon" (click)="muteclick()">
						<!--<i class="volumecontrols fa fa-volume-off"></i>-->
						<span class="VolumeControlHoverClass">UNMUTE</span>
						<img id="mutebtn" class="volumeClass" src="./assets/images/unmuteicon.png" />
					</span>
				</div>
			</div>
			<div
				*ngIf="!setDisplayProperties.mp4"
				class="preroll-placehodler-img"
				[ngStyle]="{
					'background-image': 'url(/assets/images/no-display-creative.png)'
				}"
			></div>
			<div style="display: inline-block; width: 100%" class="views-data">
				<div class="table-header_label" style="margin: 0em 1em 1em 1em">
					<table class="preroll_creative_bottom_section">
						<tr>
							<td class="preroll-creative-table_svg">
								<div class="preroll-creative-table_svg_content">
									<div
										(click)="circleVideoClickEvent(0)"
										[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
										class="drawCircle"
										id="svg_0Percent"
									></div>
									<div class="verticalLine"></div>
									<span id="percent0" class="preRoll-creative-footer-content">Started</span>
									<span
										class="preRoll-creative-footer-content percent-value"
										*ngIf="setDisplayProperties.percent_value_25 != null"
									>
										<span style="margin-left: 3.1em">100%</span>
									</span>
								</div>
								<div class="preroll-creative-table_svg_content">
									<div
										(click)="circleVideoClickEvent(25)"
										[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
										class="drawCircle"
										id="svg_25Percent"
									></div>
									<div class="verticalLine"></div>
									<span id="percent25" class="preRoll-creative-footer-content">25% Complete</span>
									<span
										class="preRoll-creative-footer-content percent-value"
										*ngIf="setDisplayProperties.percent_value_25 != null"
									>
										<span>{{ setDisplayProperties.percent_rate_25 }}%</span>
										<span style="margin-left: 0.5em"
											>{{ setDisplayProperties.percent_value_25 | formatNumber }}
											Views
										</span>
									</span>
								</div>
								<div class="preroll-creative-table_svg_content">
									<div
										(click)="circleVideoClickEvent(50)"
										[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
										class="drawCircle"
										id="svg_50Percent"
									></div>
									<div class="verticalLine"></div>
									<span id="percent50" class="preRoll-creative-footer-content">50% Complete</span>
									<span
										class="preRoll-creative-footer-content percent-value"
										*ngIf="setDisplayProperties.percent_value_50 != null"
									>
										<span>{{ setDisplayProperties.percent_rate_50 }}%</span>
										<span style="margin-left: 0.5em"
											>{{ setDisplayProperties.percent_value_50 | formatNumber }}
											Views
										</span>
									</span>
								</div>
								<div class="preroll-creative-table_svg_content">
									<div
										(click)="circleVideoClickEvent(75)"
										[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
										class="drawCircle"
										id="svg_75Percent"
									></div>
									<div class="verticalLine"></div>
									<span id="percent75" class="preRoll-creative-footer-content">75% Complete</span>
									<span
										class="preRoll-creative-footer-content percent-value"
										*ngIf="setDisplayProperties.percent_value_75 != null"
									>
										<span>{{ setDisplayProperties.percent_rate_75 }}%</span>
										<span style="margin-left: 0.5em"
											>{{ setDisplayProperties.percent_value_75 | formatNumber }}
											Views
										</span>
									</span>
								</div>
								<div class="preroll-creative-table_svg_content">
									<div
										(click)="circleVideoClickEvent(100)"
										[ngStyle]="{ 'background-color': defaultColor, color: primaryColor, opacity: '1.0' }"
										class="drawCircle"
										id="svg_100Percent"
									></div>
									<span id="percent100" class="preRoll-creative-footer-content">100% Complete</span>
									<span
										class="preRoll-creative-footer-content percent-value"
										*ngIf="setDisplayProperties.percent_value_100 != null"
									>
										<span style="margin-left: -0.7em">{{ setDisplayProperties.percent_rate_100 }}%</span>
										<span style="margin-left: 0.5em"
											>{{ setDisplayProperties.percent_value_100 | formatNumber }}
											Views
										</span>
									</span>
								</div>
							</td>
							<td>
								<div>
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Impressions</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.impressions != null"
													>{{ setDisplayProperties.impressions | formatNumber }}</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div>
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Clicks</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.clicks != null"
													>{{ setDisplayProperties.clicks | formatNumber }}</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div>
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Click Rate</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.click_rate != null"
													>{{ setDisplayProperties.click_rate }}%</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div>
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Completions</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_value_100 != null"
													>{{ setDisplayProperties.percent_value_100 | formatNumber }}</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div>
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Completion Rate</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_rate_100 != null"
													>{{ setDisplayProperties.completion_rate }}%</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div *ngIf="youtubeViewsPermission && isR1">
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">YouTube Views</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_rate_100 != null"
													>{{ setDisplayProperties.youtube_verified_imprs | formatNumber }}</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div *ngIf="youtubeViewsPermission && isR1">
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">YouTube View Rate</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_rate_100 != null"
													>{{ setDisplayProperties.youtube_verified_imprs_rate }}%</span
												>
											</td>
										</tr>
									</table>
								</div>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		<div *ngIf="isR8" class="c-portlet__content u-pt-small">
			<div style="display: inline-block; width: 100%" class="views-data above-data">
				<div class="table-header_label" style="margin: 0em 1em 1em 1em">
					<table class="preroll_creative_bottom_section">
						<tr>
							<td>
								<div>
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Impressions</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.impressions != null"
													>{{ setDisplayProperties.impressions | formatNumber }}</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div>
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Clicks</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.clicks != null"
													>{{ setDisplayProperties.clicks | formatNumber }}</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div>
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Click Rate</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.click_rate != null"
													>{{ setDisplayProperties.click_rate }}%</span
												>
											</td>
										</tr>
									</table>
								</div>
							</td>
						</tr>
					</table>
				</div>
			</div>
			<div
				*ngIf="!isGam && setDisplayProperties.mp4"
				class="o-stack o-stack&#45;&#45;center preroll-creative-img"
				id="videoDisplayblock"
			>
				<div style="margin: 1em 1em 0em 1em; width: 100%; background-color: black">
					<div class="ShowControls" *ngIf="!isSocial && !isRadio">
						<video
							class=""
							(click)="controlsOptions()"
							[hidden]="showLoad"
							style="width: 100%"
							id="preRollvideo"
							autoplay
							muted
							#videoName
							[src]="setDisplayProperties.mp4"
						>
							<source type="video/mp4" />
							Your browser does not support HTML5 video.
						</video>
						<div class="showIconsControls">
							<span class="playVideo" (click)="playclickEvent()">
								<img id="playBtn" class="volumeClass" src="./assets/images/play.png" />
							</span>
							<span class="playVideo" (click)="pauseclickEvent()">
								<img id="pauseBtn" class="volumeClass" src="./assets/images/pause.png" />
							</span>
						</div>
					</div>
				</div>
				<div class="volumecontrols" [hidden]="showLoad">
					<span id="volumeBtn" class="volumeControlIcon" (click)="volumeclick()">
						<!--<i class="volumecontrols fa fa-volume-up"></i>-->
						<span class="VolumeControlHoverClass">&nbsp;&nbsp;&nbsp;MUTE&nbsp;&nbsp;&nbsp;</span>
						<img id="volumebtn" class="volumeClass" src="./assets/images/muteicon.png" />
					</span>
					<span id="muteBtn" class="volumeControlIcon" (click)="muteclick()">
						<!--<i class="volumecontrols fa fa-volume-off"></i>-->
						<span class="VolumeControlHoverClass">UNMUTE</span>
						<img id="mutebtn" class="volumeClass" src="./assets/images/unmuteicon.png" />
					</span>
				</div>
			</div>
			<div
				*ngIf="!isGam && !setDisplayProperties.mp4 && !showLoad"
				class="preroll-placehodler-img"
				[ngStyle]="{
					'background-image': 'url(/assets/images/no-display-creative.png)'
				}"
			></div>
			<div
				*ngIf="isGam && isGamVideoCreativeAvailable"
				class="o-stack o-stack&#45;&#45;center preroll-creative-img"
				id="videoDisplayblock"
			>
				<div style="margin: 1em 1em 0em 1em; width: 100%; background-color: black">
					<div class="ShowControls" *ngIf="!isSocial && !isRadio">
						<video
							class=""
							(click)="controlsOptions()"
							[hidden]="showLoad"
							style="width: 100%"
							id="preRollvideo"
							autoplay
							muted
							#videoName
							[src]="setDisplayProperties.mp4"
						>
							<source type="video/mp4" />
							Your browser does not support HTML5 video.
						</video>
						<div class="showIconsControls">
							<span class="playVideo" (click)="playclickEvent()">
								<img id="playBtn" class="volumeClass" src="./assets/images/play.png" />
							</span>
							<span class="playVideo" (click)="pauseclickEvent()">
								<img id="pauseBtn" class="volumeClass" src="./assets/images/pause.png" />
							</span>
						</div>
					</div>
				</div>
				<div class="volumecontrols" [hidden]="showLoad">
					<span id="volumeBtn" class="volumeControlIcon" (click)="volumeclick()">
						<!--<i class="volumecontrols fa fa-volume-up"></i>-->
						<span class="VolumeControlHoverClass">&nbsp;&nbsp;&nbsp;MUTE&nbsp;&nbsp;&nbsp;</span>
						<img id="volumebtn" class="volumeClass" src="./assets/images/muteicon.png" />
					</span>
					<span id="muteBtn" class="volumeControlIcon" (click)="muteclick()">
						<!--<i class="volumecontrols fa fa-volume-off"></i>-->
						<span class="VolumeControlHoverClass">UNMUTE</span>
						<img id="mutebtn" class="volumeClass" src="./assets/images/unmuteicon.png" />
					</span>
				</div>
			</div>
			<div
				*ngIf="isGam && !isGamVideoCreativeAvailable"
				class="preroll-placehodler-img"
				[ngStyle]="{
					'background-image': 'url(/assets/images/no-display-creative.png)'
				}"
			></div>
			<div
				style="display: inline-block; width: 100%"
				class="views-data"
				[ngClass]="{ 'no-gam-creative': !isGamVideoCreativeAvailable }"
			>
				<div class="table-header_label" style="margin: 0em 1em 1em 1em">
					<table class="preroll_creative_bottom_section">
						<tr>
							<td>
								<div>
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Completions</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_value_100 != null"
													>{{ setDisplayProperties.percent_value_100 | formatNumber }}</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div>
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">Completion Rate</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_rate_100 != null"
													>{{ setDisplayProperties.completion_rate }}%</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div *ngIf="youtubeViewsPermission && isR8 && !isGam">
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">YouTube Views</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_rate_100 != null"
													>{{ setDisplayProperties.youtube_verified_imprs | formatNumber }}</span
												>
											</td>
										</tr>
									</table>
								</div>
								<div *ngIf="youtubeViewsPermission && isR8 && !isGam">
									<table class="preroll-creative-table">
										<tr>
											<td>
												<span class="table-header_label">YouTube View Rate</span>
											</td>
										</tr>
										<tr>
											<td>
												<span
													class="preRoll-creative-values-footer-content"
													*ngIf="setDisplayProperties.percent_rate_100 != null"
													>{{ setDisplayProperties.youtube_verified_imprs_rate }}%</span
												>
											</td>
										</tr>
									</table>
								</div>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary u-color-white-900 c-portlet_box_specs r8-no-data"
		*ngIf="!hasData"
	>
		<img src="/assets/images/no-creative-performance-data-preroll.png" class="no-creative-data" width="100%" />
	</div>
</div>
